<template>
    <div class="u-full-height u-flex u-flex-col">
        <div class="mb-24">
            <h2 class="u-text-normal mb-12">Statistik</h2>
        </div>

        <loading-overlay :active="isLoading">
            <div v-if="statisticsData">
                <div class="row">
                    <statistics-card text="Dokumente" size="6" :number="statisticsData.documents.numDocuments" number-theme="primary" />
                    <statistics-card text="Tags" size="6" :number="statisticsData.tags.numTags" number-theme="primary" />
                </div>

                <div class="row">
                    <template v-if="statisticsData.tags.topThreeTags.length">
                        <statistics-card>
                            <p class="mb-24" style="font-size: 2rem;">Top 3 Tags</p>
                            <div class="row u-full-width">
                                <div
                                    class="col-12 col-md-4 u-text-center mb-18 mb-0@md"
                                    v-for="(tag, i) in statisticsData.tags.topThreeTags"
                                    :key="`top-three-tag-${i}`"
                                >
                                    <router-link
                                        class="tag u-block bg-primary text-white p-6"
                                        :to="{ name: 'Documents', query: { searchTerm: tag } }"
                                    >{{ tag }}</router-link>
                                </div>
                            </div>
                        </statistics-card>
                    </template>
                </div>

                <div class="row">
                    <statistics-card size="6">
                        <tag-spreading :data-points="statisticsData.tags.tagSpreading" />
                    </statistics-card>
                    <statistics-card size="6">
                        <year-spreading :data-points="statisticsData.yearSpreading" />
                    </statistics-card>
                </div>
            </div>
            <div v-else-if="!isLoading" class="u-flex u-flex--center u-flex-grow pt-56">
                <div class="u-text-center">
                    <app-icon name="x" :scale="4" hidden class="mb-12"/>
                    <p class="text-mute">Es ist ein Fehler aufgetreten.</p>
                </div>
            </div>
        </loading-overlay>
    </div>
</template>

<script>
import AppIcon from '@/components/ui/Icon.vue'
import LoadingOverlay from '@/components/LoadingOverlay.vue'
import StatisticsCard from '@/components/StatisticsCard.vue'
import YearSpreading from '@/components/pie-chart/yearSpreading.vue'
import TagSpreading from '@/components/pie-chart/tagSpreading.vue'

export default {
    name: 'Statistics',

    components: { TagSpreading, YearSpreading, StatisticsCard, AppIcon, LoadingOverlay },

    computed: {
        hasApproxDocumentsPerTime () {
            return this.statisticsData.documents.numDocumentsPerMonth && this.statisticsData.documents.numDocumentsPerYear
        },
    },

    data: () => ({
        isLoading: false,

        /**
         * If any parameter is null or [] there is not sufficient data to elaborate.
         *
         * {
         *     documents: {
         *         numDocuments: 0,
         *         numDrafts: 0,
         *         numArchived: 0,
         *         numMailDocuments: 0,
         *         numCloudDocuments: 0,
         *         numDocumentsPerMonth: 0,
         *         numDocumentsPerYear: 0,
         *     },
         *     tags: {
         *         numTags: 0,
         *         topThreeTags: [],
         *         tagSpreading: [],
         *     },
         *     yearSpreading: [],
         * }
         */
        statisticsData: null,
    }),

    mounted () {
        this.loadStatistics()
    },

    methods: {
        async loadStatistics () {
            this.isLoading = true

            try {
                const response = await this.$http.get('/statistics')
                this.statisticsData = response.data
            } catch (e) {
                console.log(e)
                this.$toast.open({ type: 'error', message: e.message })
            } finally {
                setTimeout(() => {
                    this.isLoading = false
                }, 250)
            }
        },
    },
}
</script>

<style lang="scss" scoped>
/deep/ .tag {
    border: 1px solid darken($tertiary-color, 5%);
}
</style>
